'use client';

import React, { useMemo } from 'react';
import { useTheme } from 'styled-components';
import AlertDialog from '@/components/molecules/AlertDialog';
import usePlaylistsHook from '@/hooks/usePlaylistsHook';
import { useHomeData } from '@/hooks/useHomeData';
import Spinner from '@/components/atoms/Spinner';
import BotaoEscolherPlaylist from '@/components/molecules/BotaoEscolherPlaylist';

export type ModalAdicionarPlaylistProps = {
  $visivel: boolean;
  $fichaID: string;
  $cancelarBotaoFuncao: () => void;
};

export default function ModalAdicionarPlaylist(
  props: ModalAdicionarPlaylistProps,
) {
  const { $visivel, $fichaID, $cancelarBotaoFuncao } = props;
  const theme = useTheme();

  const { adicionarVerDepois, adicionarFavorito, adicionarPlaylist, loading } =
    usePlaylistsHook();
  const { playlistsUsuario, favoritos, verDepois, loadingListasUsuario } =
    useHomeData();

  const favoritado = useMemo(
    () => favoritos?.some((f) => f.tituloID === $fichaID) || false,
    [favoritos, $fichaID],
  );

  function favoritar() {
    adicionarFavorito({
      fichaID: $fichaID,
      adicionar: !favoritado,
    });
  }

  return (
    <AlertDialog
      $size={2}
      $visivel={$visivel}
      $titulo="Adicionar em"
      style={{ maxHeight: '70%', width: '60%' }}
      $descricao=""
      $contentContainerStyle={{
        paddingRight: theme.spacing[5],
        paddingLeft: theme.spacing[5],
      }}
      $Slot={
        loading || loadingListasUsuario ? (
          <div
            style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spinner
              tamanho={50}
              corPrincipal={theme.colors.accent.accent[5]}
            />
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: theme.spacing[5],
            }}
          >
            <BotaoEscolherPlaylist
              $onClick={favoritar}
              $tipo="favoritos"
              $nome={'Favoritos'}
              $descricao={
                favoritos?.length == null
                  ? 'Nenhum conteúdo'
                  : `${favoritos?.length} conteúdos`
              }
              $selecionado={favoritado}
              $imagem={
                favoritos != null &&
                favoritos?.length > 0 &&
                favoritos[0].posterUrlx1 != undefined
                  ? favoritos[0].posterUrlx1
                  : ''
              }
            />

            <BotaoEscolherPlaylist
              $onClick={() =>
                adicionarVerDepois({
                  fichaID: $fichaID,
                  adicionar: !verDepois?.some((f) => f.tituloID === $fichaID),
                })
              }
              $tipo="verDepois"
              $nome={'Ver depois'}
              $descricao={
                verDepois?.length == null
                  ? 'Nenhum conteúdo'
                  : `${verDepois?.length} conteúdos`
              }
              $selecionado={
                verDepois?.some((f) => f.tituloID === $fichaID) || false
              }
              $imagem={
                verDepois != null &&
                verDepois?.length > 0 &&
                verDepois[0].posterUrlx1 != undefined
                  ? verDepois[0].posterUrlx1
                  : ''
              }
            />
            {playlistsUsuario?.map((playlist) => {
              const fichaJaNaLista = playlist.titulos.some(
                (t) => t.tituloID === $fichaID,
              );
              return (
                <BotaoEscolherPlaylist
                  $onClick={() =>
                    adicionarPlaylist({
                      listaID: playlist.usuarioListaID,
                      fichaID: $fichaID,
                      adicionar: !fichaJaNaLista,
                    })
                  }
                  key={playlist.usuarioListaID}
                  $tipo="lista"
                  $nome={playlist.nome}
                  $descricao={
                    (playlist.ranking ? 'Ranking' : 'Playlist') +
                    ` • ${playlistsUsuario.length} conteúdos`
                  }
                  $selecionado={fichaJaNaLista}
                  $imagem={playlist?.titulos?.[0]?.posterUrlx1 || ''}
                />
              );
            })}
          </div>
        )
      }
      $textoBotaoCancelar="Cancelar"
      $cancelarBotaoFuncao={$cancelarBotaoFuncao}
      $esconderBotaoAcao
      $esconderBotaoCancelar
      $textoBotaoAcao=""
      $acaoBotaoFuncao={() => {}}
    />
  );
}
